import { VehiclePlate } from "@/types/vehicle-plate";

export const formatVehiclePlateToStr = (plate: VehiclePlate) => {
  return `${plate.country.toUpperCase()}.${plate.plate}`;
};

export const formatVehiclePlateToObj = (plate: string): VehiclePlate => {
  const [country, plateNumber] = plate.split(".");
  return {
    country: country.toUpperCase(),
    plate: plateNumber,
  };
};
